import { useState, useCallback, useEffect } from "react";
import ButtonCom from "../../components/button/button";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { PiPencilSimpleLineBold } from "react-icons/pi";
import { RiDeleteBinLine } from "react-icons/ri";
import { AgGridReact } from "ag-grid-react";
import { Link, useNavigate } from "react-router-dom";
import { IoReturnDownBack } from "react-icons/io5";
import { MdOutlineAssignmentTurnedIn } from "react-icons/md";
import { PiUserCheck } from "react-icons/pi";
import Modal from "react-bootstrap/Modal";
import { Button } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";

import {
  getPayrollModelListPath,
  getStaffPayrollModelListPath,
  deletePayrollModelPath,
  assignEmployeePayrollModelPath,
} from "../../services/config";
import {
  commonGetData,
  commonGetDataOne,
  commonSaveData,
  initCommonState,
} from "../../redux/slices/commonSlice";
import { useDispatch, useSelector } from "react-redux";

const Payroll = () => {
  const user = localStorage.getItem("user_data")
    ? JSON.parse(localStorage.getItem("user_data"))
    : null;

  const navigate = useNavigate()
  const dispatch = useDispatch();
  const commonState = useSelector((state) => state.common);

  const [payrollList, setPayrollList] = useState([]);

  const [show, setShow] = useState(false);
  const [show1, setShow1] = useState(false);
  const [payrollId, setPayrollId] = useState("");
  const [employeeList, setEmployeeList] = useState([]);
  const [filterEmployeeList, setFilterEmployeeList] = useState([]);
  const [selectIs, setSelectIs] = useState(true);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const isSelectAll =
    selectedUsers.length === employeeList.length && employeeList.length > 0;

  const getPayrollModelList = useCallback(() => {
    dispatch(commonGetData(getPayrollModelListPath + user.user_id));
  }, []);

  useState(() => {
    getPayrollModelList();
  }, []);

  const getEmployeeList = useCallback((id) => {
    dispatch(commonGetDataOne(getStaffPayrollModelListPath(user.user_id, id)));
  }, []);

  const heading = [
    {
      headerName: "Model Name",
      cellRenderer: (rowData) => {
        return rowData.data.payrollModelName;
      },
      flex: 1,
    },

    {
      headerName: "Action",
      width: 200,
      cellRenderer: (rowData) => {
        return (
          <>
            <div className="Branches-table-button">
              <PiUserCheck
                style={{
                  cursor: "pointer",
                  fontSize: 25,
                  marginRight: "10px",
                }}
                className="assign-icon"
                onClick={() => {
                  handleShow();
                  handleAssignId(rowData.data.payrollModelId);
                }}
              />

              <PiPencilSimpleLineBold
                onClick={() => updatePayroll(rowData.data)}
                style={{ cursor: "pointer", fontSize: 30, color: "blue" }}
              />

              <RiDeleteBinLine className="delete-icon"
                onClick={() => handleDeletePayroll(rowData.data.payrollModelId)}
                style={{ cursor: "pointer", fontSize: 30, color: "red" }}
              />
            </div>
          </>
        );
      },
    },
  ];

  const handleModalClose1 = () => {
    setShow1(false);
  };

  const handleShow1 = () => setShow1(true);

  const handleDeletePayroll = (id) => {
    setPayrollId(id);
    handleShow1(true);
  };

  const handleDeleteSubmit = () => {
    const data = {
      path: deletePayrollModelPath,
      data: {
        userId: user.user_id,
        payrollModelId: payrollId,
      },
    };
    dispatch(commonSaveData(data));
  };

  const handleAssignId = (id) => {
    setPayrollId(id);
    getEmployeeList(id);
  };

  const handleModalClose = () => {
    setShow(false);
  };

  const handleShow = () => setShow(true);

  const selectUser = (event, userId) => {
    const isChecked = event.target.checked;
    setSelectedUsers((prevSelected) =>
      isChecked
        ? [...prevSelected, userId]
        : prevSelected.filter((id) => id !== userId)
    );
  };

  const SelectAll = (event) => {
    const isChecked = event.target.checked;
    if (isChecked) {
      const allUserIds = employeeList.map((row) => row.staffId);
      setSelectedUsers(allUserIds);
    } else {
      setSelectedUsers([]);
    }
  };

  const handleAssignShiftSubmit = (e) => {
    e.preventDefault();
    const data = {
      path: assignEmployeePayrollModelPath,
      data: {
        userId: user.user_id,
        staffId: selectedUsers.toString(),
        payrollModelId: payrollId,
      },
    };
    dispatch(commonSaveData(data));
  };

  const updatePayroll = (data) => {
    localStorage.setItem("payroll-data", JSON.stringify(data))
    navigate("/update-payroll-model")
  }

  useEffect(() => {
    if (commonState.commonGetSuccess || commonState.commonGetError) {
      if (commonState.commonGetSuccess) {
        setPayrollList(commonState.commonGetData);
        dispatch(initCommonState());
      }
    }
    if (commonState.commonGetOneSuccess || commonState.commonGetOneError) {
      if (commonState.commonGetOneSuccess) {
        setEmployeeList(commonState.commonGetOneData);
        setFilterEmployeeList(commonState.commonGetOneData);
        const initiallySelected = commonState.commonGetOneData
          .filter(row => row.payrollAssignedStatus === "1") // Check API ka "selected: true"
          .map(row => row.staffId);

        setSelectedUsers(initiallySelected);
        dispatch(initCommonState());
      }
    }
    if (commonState.commonSuccess || commonState.commonError) {
      commonState.commonSuccess
        ? toast.success(commonState.commonMessage)
        : toast.error(commonState.commonMessage);
      getPayrollModelList();
      handleModalClose();
      handleModalClose1();
      dispatch(initCommonState());
    }
  }, [dispatch, commonState]);

  const searchEmployees = (val) => {
    setSearchQuery(val);
    const filteredEmployees = filterEmployeeList.filter((v) =>
      v.full_name.toLowerCase().includes(val.toLowerCase())
    );
    setEmployeeList(filteredEmployees);
  };

  const paginationPageSize = 10;
  const paginationPageSizeSelector = [10, 20, 50, 100];

  return (
    <div className="body-container">
      <div className="page-top-bar">
        <div
          style={{
            display: "flex",
            alignItem: "center",
            justifyContent: "start",
            gap: "10px",
          }}
        >
          <Link to={"/setting"}>
            <ArrowBackIcon sx={{ scale: 1 }} style={{ color: "gray" }} />
          </Link>
          <h1 style={{ fontSize: "20px", fontWeight: "400" }}>Payroll Model</h1>
        </div>
        <ButtonCom
          type={"link"}
          class_name={"p_btn"}
          text="Create Payroll Model"
          url_or_onclick={"/payroll-template"}
          icon={null}
          width={""}
        />
      </div>
      <div
        className="page-body p-5"
        style={{ marginBottom: "50px", height: "100dvh" }}
      >
        <div className="ag-theme-quartz" style={{ height: 500, width: "100%" }}>
          <AgGridReact
            rowData={Array.isArray(payrollList) ? payrollList : []}
            columnDefs={heading}
            omLayout="autoHeight"
            pagination={true}
            paginationPageSize={paginationPageSize}
            paginationPageSizeSelector={paginationPageSizeSelector}
          />
        </div>
      </div>

      <Modal show={show} onHide={handleModalClose} backdrop="static">
        <Modal.Header closeButton>
          <Modal.Title>Assign Employee to this Shift</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ display: "flex", flexDirection: "column" }}>
          <input
            className="search-employee"
            type="text"
            placeholder="Search employees..."
            value={searchQuery}
            onChange={(e) => searchEmployees(e.target.value)}
          />
          <table className="payroll-tbl">
            <thead>
              <tr>
                <th>
                  <input
                    type="checkbox"
                    checked={isSelectAll}
                    onChange={SelectAll}
                    id="sel-all"
                    className="colored-checkbox"
                  />
                  &nbsp; &nbsp;
                  <label style={{ cursor: "pointer" }} htmlFor="sel-all">
                    Select All
                  </label>
                </th>
                <th>Employee Name</th>
              </tr>
            </thead>
            <tbody>
              {employeeList.length > 0 ? (
                employeeList.map((row) => (
                  <tr key={row.staffId}>
                    <td>
                      <input
                        type="checkbox"
                        checked={
                          selectedUsers.includes(row.staffId)
                        }
                        onChange={(e) => selectUser(e, row.staffId)}
                        id={"shift" + row.staffId}
                        className="colored-checkbox"
                      />
                    </td>
                    <td
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "5px",
                      }}
                    >
                      <label
                        style={{ cursor: "pointer" }}
                        htmlFor={"shift" + row.staffId}
                      >
                        {row.full_name}
                      </label>
                      <span style={{ fontSize: "12px", color: "gray" }}>
                        {row.employee_id}
                      </span>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="2">No employees found</td>
                </tr>
              )}
            </tbody>
          </table>
        </Modal.Body>
        <Modal.Footer>
          <Button
            style={{
              backgroundColor: "#566573",
              color: "#fff",
              marginRight: "5px",
            }}
            onClick={handleModalClose}
          >
            Cancel
          </Button>
          <Button
            style={{ backgroundColor: "#5dade2", color: "#fff" }}
            onClick={handleAssignShiftSubmit}
          >
            Submit
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={show1} onHide={handleModalClose1} backdrop="static">
        <Modal.Header closeButton>
          <Modal.Title>Delete Payroll Model</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure! to delete this record?</Modal.Body>
        <Modal.Footer>
          <Button
            style={{
              backgroundColor: "gray",
              color: "#fff",
              marginRight: "5px",
            }}
            onClick={handleModalClose1}
          >
            Cancel
          </Button>
          <Button
            style={{ backgroundColor: "red", color: "#fff" }}
            onClick={handleDeleteSubmit}
          >
            {commonState.commonLoading ? "Deleting.." : "Delete"}
          </Button>
        </Modal.Footer>
      </Modal>

      <ToastContainer
        position="top-right"
        autoClose={2000}
        className="toast-custom"
      />
    </div>
  );
};

export default Payroll;
